import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import XLSX from "xlsx";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

    
const categorias = [
	{
		value: "1",
		label: "Experto en producto"
	},
	{
		value: "2",
		label: "Vacunación"
	},
	{
		value: "3",
		label: "Solution Selling"
	}
];

  
const gametypes = [
	{
		value: "0",
		label: "Pregunta/Respuesta"
	},
	{
		value: "1",
		label: "Conectar"
	},
	{
		value: "2",
		label: "Afirmación"
	}
];


class Questions extends Component {
	constructor(props) {
		super(props);
		this.state = {
            category: "",
            level: "",
            levelcategory:"",
            levels: [],
			levelcategories: [],
			gametype: 0,
			columnDefs: [
				{ headerName: "Categoria", field: "categoryname", width: "150" },
				{ headerName: "Nivel", field: "levelname", width: "150" },
				{ headerName: "Subcategoria", field: "levelcategoryname", width: "150" },
				{ headerName: "Pregunta", field: "question", width: "400" },
                { headerName: "Respuesta 1", field: "answer1", width: "300" },
                { headerName: "Respuesta 2", field: "answer2", width: "300" },
                { headerName: "Respuesta 3", field: "answer3", width: "300" },
                { headerName: "Respuesta 4", field: "answer4", width: "300" }
			]
		};
    }


	handleCreateQuestion = () => {
		this.setState({
			createNew: true
		});
    };
    
	handleCancel = () => {
		this.setState({
			createNew: false
		});
    };

    handleConfirm = () => {

		if(this.state.gametype == 0 ||this.state.gametype == 2 )
		{
			if(this.state.category &&
			this.state.level &&
			this.state.levelcategory &&
			this.state.question &&
			this.state.answer1 &&
			this.state.answer2)
			this.props.handleSaveQuestion({
				"category":this.state.category,
				"level":this.state.level,
				"levelcategory":this.state.levelcategory,
				"gametype":this.state.gametype,
				"question":this.state.question,
				"answer1":this.state.answer1,
				"answer2":this.state.answer2,
				"answer3":this.state.answer3,
				"answer4":this.state.answer4,
				"iscorrect1":this.state.isCorrect1 ? 1 : 0,
				"iscorrect2":this.state.isCorrect2 ? 1 : 0,
				"iscorrect3":this.state.isCorrect3? 1 : 0,
				"iscorrect4":this.state.isCorrect4? 1 : 0
			});
		}else if(this.state.gametype == 1)
		{
			if(this.state.category &&
				this.state.level &&
				this.state.levelcategory &&
				this.state.question &&
				this.state.option1left &&
				this.state.option1right &&
				this.state.option2left &&
				this.state.option2right)
				this.props.handleSaveQuestionConnect({
					"category":this.state.category,
					"level":this.state.level,
					"levelcategory":this.state.levelcategory,
					"question":this.state.question,
					"option1left":this.state.option1left,
					"option1right":this.state.option1right,
					"option2left":this.state.option2left,
					"option2right":this.state.option2right,
					"option3left":this.state.option3left,
					"option3right":this.state.option3right,
					"option4left":this.state.option4left,
					"option4right":this.state.option4right
				});
		}
        this.setState({
            createNew: false,
            category: "",
            level: "",
            levelcategory:"",
			question:"",
			gametype: 0,
            answer1:"",
            answer2:"",
            answer3:"",
			answer4:"",
			option1left:"",
			option1right:"",
			option2left:"",
			option2right:"",
			option3left:"",
			option3right:"",
			option4left:"",
			option4right:"",
            isCorrect1: false,
            isCorrect2: false, 
            isCorrect3: false,
            isCorrect4 : false
		});
    }
    

    
	componentDidMount() {}

	render() {
		return (
			<React.Fragment>

            <Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.createNew}
				>
					<Paper
						style={{
							display: "grid",
							width: "70%",
							padding: "25px",
                            margin: "auto auto",
                            height: "90%",
                            overflowY: "auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Crear Nueva Pregunta
							<br />
                            <TextField
								id="standard-select"
								select
								label="Tipo Juego"
								style={{
                                 
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.gametype}
								onChange={value =>{
                                    this.setState({ gametype: value.target.value });
                                    //this.props.loadLevels(value.target.value);
                                    }
								}
							>
								{gametypes.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
							<br />
                            <TextField
								id="standard-select"
								select
								label="Categoría"
								style={{
                                 
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.category}
								onChange={value =>{
                                    this.setState({ category: value.target.value });
                                    this.props.loadLevels(value.target.value);
                                    }
								}
							>
								{categorias.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
							<br />
                            
                            <TextField
								id="standard-select"
								select
								label="Nivel"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.level}
								onChange={value => {
                                    this.props.loadLevelCategories(value.target.value);
									this.setState({ level: value.target.value })
                                }
                            }
							>
								{this.props.levels.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
                            <br />
                            <TextField
								id="standard-select"
								select
								label="Sub-Categoría"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.levelcategory}
								onChange={value =>
									this.setState({ levelcategory: value.target.value })
								}
							>
								{this.props.levelCategories ?
								this.props.levelCategories.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								)):null}
							</TextField>
							<br />
							<TextField
								id="outlined-basic"
								label="Pregunta"
                                variant="outlined"
                                multiline
								value={this.state.question}
								onChange={value => this.setState({ question: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							{
								this.state.gametype == 0 || this.state.gametype == 2 ?
							(
							<React.Fragment>
                            <br />
							<TextField
								id="outlined-basic"
								label="Respuesta 1"
								variant="outlined"
								multiline
								value={this.state.answer1}
								onChange={value => this.setState({ answer1: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                    checked={this.state.isCorrect1}
                                    onChange={event => this.setState({ isCorrect1: event.target.checked })} 
                                    label="Es Correcta?" 
                                    inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
							
                            <TextField
								id="outlined-basic"
								label="Respuesta 2"
								variant="outlined"
								multiline
								value={this.state.answer2}
								onChange={value => this.setState({ answer2: value.target.value })}
								style={{ width: "90%", textAlign: "left" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                    checked={this.state.isCorrect2}
                                    onChange={event => this.setState({ isCorrect2: event.target.checked })} 
                                    label="Es Correcta?" inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} 
                                    />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
							<TextField
								id="outlined-basic"
								label="Respuesta 3"
								variant="outlined"
								multiline
								value={this.state.answer3}
								onChange={value => this.setState({ answer3: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                       
                                    <Checkbox 
                                        checked={this.state.isCorrect3}
                                        onChange={event => this.setState({ isCorrect3: event.target.checked })} 
                                        label="Es Correcta?" 
                                        inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
                            <TextField
								id="outlined-basic"
								label="Respuesta 4"
								variant="outlined"
								multiline
								value={this.state.answer4}
								onChange={value => this.setState({ answer4: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                    checked={this.state.isCorrect4}
                                    onChange={event => this.setState({ isCorrect4: event.target.checked })} 
                                    label="Es Correcta?" 
                                    inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
							</React.Fragment>
							):null}
							{
								this.state.gametype == 1 ? 
								(
									<React.Fragment>
									<br />		
										<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción 1</div>
										<TextField
								id="outlined-basic"
								label="Izquierda"
								variant="outlined"
								multiline
								value={this.state.option1left}
								onChange={value => this.setState({ option1left: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="outlined-basic"
								label="Derecha"
								variant="outlined"
								multiline
								value={this.state.option1right}
								onChange={value => this.setState({ option1right: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />	
								<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción 2</div>
								<TextField
								id="outlined-basic"
								label="Izquierda"
								variant="outlined"
								multiline
								value={this.state.option2left}
								onChange={value => this.setState({ option2left: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="outlined-basic"
								label="Derecha"
								variant="outlined"
								multiline
								value={this.state.option2right}
								onChange={value => this.setState({ option2right: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción 3</div>
								<TextField
								id="outlined-basic"
								label="Izquierda"
								variant="outlined"
								multiline
								value={this.state.option3left}
								onChange={value => this.setState({ option3left: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="outlined-basic"
								label="Derecha"
								variant="outlined"
								multiline
								value={this.state.option3right}
								onChange={value => this.setState({ option3right: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							<div style={{textAlign:"left", marginLeft: "50px", marginBottom:"10px"}} >Opción 4</div>
								<TextField
								id="outlined-basic"
								label="Izquierda"
								variant="outlined"
								multiline
								value={this.state.option4left}
								onChange={value => this.setState({ option4left: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="outlined-basic"
								label="Derecha"
								variant="outlined"
								multiline
								value={this.state.option4right}
								onChange={value => this.setState({ option4right: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br /><br />

									</React.Fragment>
								):null
							}
							<Button
								onClick={this.handleConfirm}
								type="submit"
								color="primary"
								variant="contained"
								style={{ backgroundColor: "#00adee" }}
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button onClick={this.handleCancel} color="primary">
								Cancelar
							</Button>
							<br /><br />
						</div>
					</Paper>
				</Modal>


				<h2 style={{ width: "100%", textAlign: "left" }}>Preguntas</h2>
                <div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.handleCreateQuestion}
						color="primary"
						variant="contained"
					>
						Agregar Pregunta
					</Button>
				</div>

				<div
					className="ag-theme-balham"
					style={{ height: "80vh", width: "100%" }}
				>
					<AgGridReact
						enableSorting={true}
						enableFilter={true}
						columnDefs={this.state.columnDefs}
						rowData={this.props.questions}
					></AgGridReact>
				</div>
			</React.Fragment>
		);
	}
}

export default Questions;
